import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { PRICING_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider } from "@tour"
import {isSystemBusy} from "@signals";
import PricingPriceEvolutionFilters from "./Filters"
import { PriceEvolutionIsEmpty, resetRetailerPriceEvolutionFilters } from "./@signals"
import PriceEvolutionContent from "./Content"


export default function PricingPriceEvolutionPage() {

    useEffect(() => {
        return () => resetRetailerPriceEvolutionFilters()
    }, [])

    return <PageWrapper
        tourPageKey="priceEvolution"
        head={`DIP Insight | ${PRICING_ROUTES.PRICE_EVOLUTION_TITLE}`}
        title={PRICING_ROUTES.PRICE_EVOLUTION_TITLE}
        subtitle={PRICING_ROUTES.PRICE_EVOLUTION_SUBTITLE}
        filters={<PricingPriceEvolutionFilters />}
        isEmpty={PriceEvolutionIsEmpty.value}
        hasErrors={isSystemBusy.value}
    >
        <Grid container spacing={1}>
            <PriceEvolutionContent />
        </Grid>
    </PageWrapper>
}
